import React, { useState } from 'react';
import { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Box, TextFieldProps, useTheme } from '@mui/material';
import { Grid } from '@mui/system';

interface CardDatePickerProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  minDate?: Dayjs | null;
  maxDate?: Dayjs | null;
}

const LabelDatePicker: React.FC<CardDatePickerProps> = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled = false,
  label,
  placeholder,
  ...textFieldProps
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  const onClickCard = () => {
    if (open) return;
    setOpen(true);
  };

  const onOpen = () => setOpen(true);

  const onClose = () => setOpen(false);

  return (
    <Grid container width='100%' onClick={onClickCard}>
      <Box sx={{ maxWidth: theme.spacing(15) }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            format='M/D/YY'
            value={value}
            onChange={newDate => {
              onChange(newDate);
              setTimeout(onClose, 0);
            }}
            minDate={minDate || undefined}
            maxDate={maxDate || undefined}
            disabled={disabled}
            slots={{
              openPickerIcon: () => null,
              inputAdornment: () => null,
            }}
            slotProps={{
              textField: {
                ...textFieldProps,
                readOnly: true,
                fullWidth: true,
                label,
                placeholder,
                variant: 'outlined',
                InputProps: {
                  ...textFieldProps.InputProps,
                  disableUnderline: true,
                  endAdornment: null,
                },
                inputProps: {
                  style: {
                    textAlign: 'center',
                    cursor: 'pointer',
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </Box>
    </Grid>
  );
};

export default LabelDatePicker;
